import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationModules } from './application-modules';

export function setupAllModules(): void {
  ApplicationModules.forEach(module => {
    applicationModuleRegistry.register(module);
  });
}